export default {
  parameters: {
    landing_id: "ClAu2",
  },
  downtimeUrl: "https://cl.kodland.tech",
  startPage: {
    image: "/welcome/quiz_project_girl.jpeg",
    title: "Responde estas 5 preguntas y accede a clases GRATIS para tu hijo/a",
    button: "Presiona para continuar 🚀",
  },
  successPage: {
    title: "¡Felicitaciones! 🎁",
    subtitle: "Haz clic en '📆 Reservar una lección' para completar el registro",
    button: "📆 Reservar una clase",
  },
  quizRotateBySteps: {
    1: {
      question: "¿Qué hace tu hijo/a en su tiempo libre?",
      answers: [
        "📱 Juega en el teléfono o la computadora",
        "👾 Ve dibujos animados",
        "⚽️ Hace actividades deportivas",
        "🎨 Le gustan las actividades artísticas: dibujar, escuchar música, actuar, etc.",
        "❓ Saltar la pregunta",
      ],
    },
    2: {
      question: "¿Tu hijo/a participa en actividades extracurriculares fuera del aprendizaje escolar?",
      answers: [
        "📚 Clases que ayudan a aumentar el valor del aprendizaje",
        "⛹️ Sí Actividades deportivas",
        "🎨 Sí. Clases de arte",
        "💻 Sí. Clases de codificación e informática",
        "✖️ No. Los niños no tienen tiempo para eso",
      ],
    },
  },
};

